module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/ielts/sections/ai/assets/sparkle_icon-b932a418575d2331fddaa1133ca8ce49.svg";